import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from '@atlas/components';
import { BasePopup, Icon, Label } from '@atlas/ui';

import { CDN_TYPE_BASE, imageUrlCDN } from 'common/utils/utils';
import MoneyValueCustomCurrency from 'src/components/MoneyValueCustomCurrency/MoneyValueCustomCurrency';

const DepositLoadingPopup = ({ data }) => {
  const { amount, pmImage, pmName, text, title } = data;
  const imageStyle = pmImage
    ? { backgroundImage: `url(${imageUrlCDN(pmImage, CDN_TYPE_BASE)})` }
    : {};

  return (
    <BasePopup className="deposit-loading-popup">
      <div className="popup__content">
        <Label className="popup__title" message={title} />
        <div className="popup__info">
          <MoneyValueCustomCurrency className="payment-amount" value={amount} />
          <div className="payment-method__info">
            <div className="payment-method__image" style={imageStyle}>
              {!pmImage && <Icon name="money" />}
            </div>
            <span className="payment-method__name">{pmName}</span>
          </div>
        </div>
        <Label className="popup__text" message={text} />
        <Loader className="popup__loader" />
      </div>
    </BasePopup>
  );
};

DepositLoadingPopup.propTypes = {
  data: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    pmImage: PropTypes.string,
    pmName: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default DepositLoadingPopup;
